import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '@media (max-width: 700px)': {
      flexDirection: 'column',
    },
  },
  cards: {
    borderRadius: '8px',
    padding: '8px',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  recommended: {
    fontSize: '9px',
    fontWeight: 400,
    color: '#163BAC',
    whiteSpace: 'nowrap',
  },
  days: {
    fontWeight: 600,
  },
  headerText: {
    fontSize: '10px',
    fontWeight: 400,
    color: '#484848',
    whiteSpace: 'nowrap',
  },
}));

const CreditMetrics = ({ data }) => {
  const classes = useStyles();

  const currentThresholdCount =
    data?.current_threshold_trip_count?.current_threshold_trip_count;
  const currentThresholdLimit =
    data?.current_threshold_trip_count?.recommended_threshold_trip_count;

  function compareDays(days, recommended) {
    if (!recommended || typeof recommended !== 'string') {
      return false;
    }
    if (recommended.startsWith('>')) {
      const recommendedNum = parseFloat(
        recommended
          .split('>')[1]
          .trim()
          .split(' ')[0]
      );
      return days < recommendedNum;
    }
    return Number(days) < Number(recommended);
  }

  const isAthPayment = compareDays(
    data?.average_ath_payment?.days,
    data?.average_ath_payment?.recommended_days
  );
  const isBthPayment = compareDays(
    data?.average_bth_payment?.days,
    data?.average_bth_payment?.recommended_days
  );
  const isCreditThreshold = compareDays(
    currentThresholdCount,
    currentThresholdLimit
  );

  return (
    <div className={classes.flexBox}>
      <div className={classes.cards}>
        <text className={classes.headerText}>AVG ATH PAYMENT</text>
        <text
          className={classes.days}
          style={{ color: isAthPayment ? '#128750' : '#B92727' }}
        >
          {`${data?.average_ath_payment?.days ?? 0} Days`}
        </text>
        <text className={classes.recommended}>
          Recommended: {data?.average_ath_payment?.recommended_days ?? '-'}
        </text>
      </div>
      <div className={classes.cards}>
        <text className={classes.headerText}>AVG BTH PAYMENT</text>
        <text
          className={classes.days}
          style={{ color: isBthPayment ? '#128750' : '#B92727' }}
        >
          {`${data?.average_bth_payment?.days ?? 0} Days`}
        </text>
        <text className={classes.recommended}>
          Recommended: {data?.average_bth_payment?.recommended_days ?? '-'}
        </text>
      </div>
      <div className={classes.cards}>
        <text className={classes.headerText}>TRIP CREDIT THRESHOLD</text>
        <div className={classes.flex}>
          <text
            className={classes.days}
            style={{ color: isCreditThreshold ? '#128750' : '#B92727' }}
          >
            {`${currentThresholdCount ?? 0}`}
          </text>
        </div>

        <text className={classes.recommended}>
          Recommended: {currentThresholdLimit ?? '--'}
        </text>
      </div>
    </div>
  );
};

export default CreditMetrics;
